// extracted by mini-css-extract-plugin
export default {"youtubeVideos":"YouTubeVideos_youtubeVideos__yk3x-"};